/**
 * The answer key of a crossword is its letters. Kept apart from the form component so the
 * eagerly loaded module file never pulls the author's form into the player bundle.
 */
import { conformRows } from "./grid";
import type { CrosswordDefinition, CrosswordSolution } from "./types";

/** What the core hands the form when nothing is queued: no rows at all. */
export function emptySolution(_definition: CrosswordDefinition): CrosswordSolution {
  return { rows: [] };
}

export function isRows(value: unknown): value is CrosswordSolution {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const rows = (value as { rows?: unknown }).rows;
  return Array.isArray(rows) && rows.every((row) => typeof row === "string");
}

/** Nothing queued: not a row set, or the empty one the core hands out. */
export function isAbsent(value: unknown): boolean {
  return !isRows(value) || value.rows.length === 0;
}

/** Reads whatever is stored, however wrong, as letters in the shape of the grid. */
export function lettersOf(value: unknown, definition: CrosswordDefinition): string[] {
  return conformRows(isRows(value) ? value.rows : undefined, definition.grid);
}
